import { styled } from 'styled-components'
import { NextSeo } from 'next-seo'
import { useTranslation } from '@pancakeswap/localization'
import { useRouter } from 'next/router'
import { DEFAULT_META, getCustomMeta } from 'config/constants/meta'
import Container from './Container'

const StyledPage = styled(Container)`
  width: 100%;
  // min-height: calc(100vh - 64px);
  // padding-top: 16px;
  // padding-bottom: 16px;
  // margin: auto;

  // ${({ theme }) => theme.mediaQueries.sm} {
  //   padding-top: 24px;
  //   padding-bottom: 24px;
  // }

  // ${({ theme }) => theme.mediaQueries.lg} {
  //   padding-top: 32px;
  //   padding-bottom: 32px;
  // }
`

export const PageMeta: React.FC<React.PropsWithChildren> = () => {
  const {
    t,
    currentLanguage: { locale },
  } = useTranslation()
  const { pathname } = useRouter()

  const pageMeta = getCustomMeta(pathname, t, locale)

  // if (!pageMeta) {
  //   return null
  // }

  // const { description, image } = { ...DEFAULT_META }

  return (
    <NextSeo
      title={pageMeta?.title}
      // description={description}
      // openGraph={
      //   image
      //     ? {
      //         images: [{ url: image, alt: pageMeta?.title, type: 'image/png' }],
      //       }
      //     : undefined
      // }
    />
  )
}

const Page: React.FC<React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>> = ({ children, ...props }) => {
  return (
    <>
      <PageMeta />
      <StyledPage {...props}>{children}</StyledPage>
    </>
  )
}

export default Page
